import { reactive, toRefs } from "vue";
import {cloneDeep} from 'lodash'
import { usePraticaStore } from "../store/crm.store";

/**
 * Gestisce la preparazione delle checklist prima del loro invio effettivo
 * Inoltre viene usato anche in fase di creazione/aggiornamento di un modello checklist
 */
export function useChecklist() {
  const checklistSoggetto = reactive({
    questionarioBoirplate: {
      questionario: {
        atom_components: {
          version: '1.0',
          title: {value: 'Checklist Documenti'},
          note: null,
          elements: null
        }
      }
    }
  })

  const praticaStore = usePraticaStore();

  /**
   * Converte oggetto in array
   * @param elements
   * @return {*|*[]}
   * @private
   */
  function _convertObjectToArray(elements) {
    if(typeof elements === 'object') {
      let arr = [];
      Object.values(elements).forEach((element) => {
        arr.push(element);
      })

      return arr;
    }

    return elements;
  }

  /**
   * Prepara oggetto della checklist da inviare
   * Sia in fase di invio e conferma checklist che in fase creazione|aggiornamento modello
   * Se is_checklist è true indica che si sta processando una vera checklist e non un modello
   *
   * @param soggettoId
   * @param richiesteDocumenti
   * @param notaChecklist
   * @param checklistId
   * @param is_checklist
   * @return {*}
   */
  function generateChecklistToSave(soggettoId, richiesteDocumenti, notaChecklist, checklistId = null, is_checklist = false) {
    if (checklistId) checklistSoggetto.questionarioBoirplate.questionario_id = checklistId;
    let checklist = cloneDeep(checklistSoggetto.questionarioBoirplate);
    if (is_checklist) {
      if (praticaStore.praticaID) checklist.pratica_id = parseInt(praticaStore.praticaID);
      checklist.soggetto_id = parseInt(soggettoId);
    }
    checklist.questionario.atom_components.elements = is_checklist ? _convertObjectToArray(richiesteDocumenti) : richiesteDocumenti;
    checklist.questionario.atom_components.title = checklist.questionario.atom_components.title.value;
    checklist.questionario.atom_components.note = notaChecklist.value;
    checklist.questionario = JSON.stringify(checklist.questionario);

    return checklist;
  }

  return {
    ...toRefs(checklistSoggetto),
    generateChecklistToSave
  }
}